module.exports = __webpack_public_path__ + "img/business_slide2.23a9ff67.png";